import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
// i18next
import { Trans, useTranslation } from 'react-i18next';
import QuizTypes from 'types/QuizTypes';

const PoweredBy:FC = () => {
  const { t } = useTranslation('common');

  const quiz = useAppSelector(selectQuiz);

  const isPollQuiz = quiz?.type === QuizTypes.Poll;

  if (quiz.whiteLabeling) return null;
  return (
    <div className="my-2">
      <h3 className="font-semibold text-center" style={{ color: isPollQuiz ? 'white' : 'initial' }}>
        <Trans
          t={t}
          components={{
            span: <span className="font-bold" style={{ fontFamily: 'Montserrat' }} />,
            span2: <span style={{ color: '#ff9100' }} />,
          }}
          i18nKey="quiz.countdownPage.poweredBy"
        />
      </h3>
    </div>
  );
}

export default PoweredBy;
